import { Paragraph } from '@limitless-minds/ui-text'
import { Stack, useTheme } from '@mui/material'
import React from 'react'

interface FooterProps {
  children: React.ReactNode
}

const Footer: React.FC<FooterProps> = ({ children }) => {
  const theme = useTheme()
  return (
    <Stack padding='2rem' gap='1rem' textAlign={{ xs: 'center', md: 'center', lg: 'start' }} alignItems='center'>
      <Paragraph variant='p14'>{children}</Paragraph>
      <Stack direction='row'>
        <Paragraph variant='p12' color={theme.palette.role.onSurfaceVariant}>
          Need assistance? Contact&nbsp;
        </Paragraph>
        <Paragraph variant='p12' bold underlined color={theme.palette.role.primary}>
          support@limitlessminds.com
        </Paragraph>
      </Stack>
    </Stack>
  )
}

export default Footer
